import React from 'react';

interface Post {
  id: string;
  author: string;
  avatar: string;
  content: string;
  timestamp: string;
  likes: number;
  comments: number;
}

const mockPosts: Post[] = [
  {
    id: '1',
    author: 'Tom Ballard',
    avatar: 'A',
    content: 'I need a new post to show',
    timestamp: '0 sec',
    likes: 0,
    comments: 0,
  }
];

export const FeedView: React.FC = () => {
  const formatTime = () => {
    const now = new Date();
    return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
  };

  return (
    <div className="feed-view">
      {/* Status Message */}
      <div className="feed-status">
        <p className="status-text">* no friends to send to - add some friends first! *</p>
        <p className="status-time">[{formatTime()}:32]</p>
      </div>

      {/* Posts */}
      <div className="feed-posts">
        {mockPosts.map((post) => (
          <div key={post.id} className="post-item">
            <div className="post-header">
              <div className="post-avatar">{post.avatar}</div>
              <div className="post-meta">
                <span className="post-author">{post.author}</span>
                <span className="post-timestamp">in {post.timestamp}</span>
                <button className="post-more">•••</button>
              </div>
            </div>
            
            <div className="post-content">
              {post.content}
            </div>
            
            <div className="post-actions">
              <button className="action-button like-button">
                <span className="action-icon">♡</span>
              </button>
              <button className="action-button comment-button">
                <span className="action-icon">💬</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
